import request from "@/global/request/request";
import API from "@/global/request/api";

const studentService = {
  list(params = {}) {
    return request.get(API.student, params);
  },
  show(id) {
    return request.get(API.studentItem(id));
  },
  stateChange(id, params = {}) {
    return request.put(API.studentItemState(id), params);
  },
  taskAdd(id, params = {}) {
    return request.post(API.studentItemTask(id), params);
  },
  taskShow(id, taskId) {
    return request.get(API.studentItemTaskItem(id, taskId));
  },
  taskEdit(id, taskId, params = {}) {
    return request.put(API.studentItemTaskItem(id, taskId), params);
  },
  taskDel(id, taskId) {
    return request.delete(API.studentItemTaskItem(id, taskId));
  },
  taskSortEdit(id, taskId, params = {}) {
    return request.put(API.studentItemTaskItemSort(id, taskId), params);
  },
  taskStateEdit(id, taskId, params = {}) {
    return request.put(API.studentItemTaskItemState(id, taskId), params);
  },
  courseList(params = {}) {
    return request.get(API.course, params);
  },
  courseShow(id) {
    return request.get(API.courseItem(id));
  },
  projectList(params = {}) {
    return request.get(API.kongfuProject, params);
  },
  projectShow(id) {
    return request.get(API.kongfuProjectItem(id));
  },
  courseCategories() {
    return request.get(API.courseCategories);
  },
  projectJobs() {
    return request.get(API.kongfuProjectJobs);
  }
};

export default studentService;
